import { useState } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import { Lock, Mail, Sparkles } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ClientLoginModal({ open, onOpenChange }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const notify = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await axios.post(`${API}/newsletter`, { email: email.trim() });
      toast.success("Thanks! We'll email you when the client portal goes live.");
      setEmail("");
      onOpenChange(false);
    } catch (err) {
      toast.error("Please enter a valid email.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="client-login-modal"
        className="bg-[#0c0c0c] border-white/10 text-white sm:max-w-md"
      >
        <DialogHeader>
          <div className="w-12 h-12 rounded-xl bg-[#D4AF37]/15 border border-[#D4AF37]/30 flex items-center justify-center text-[#D4AF37] mb-2">
            <Lock size={20} />
          </div>
          <DialogTitle className="font-display text-2xl">Client Portal — Coming Soon</DialogTitle>
          <DialogDescription className="text-gray-400">
            We're building a beautiful, secure portal where you'll see a consolidated view of all your investments,
            XIRR, goals progress and tax statements. Be the first to know when it launches.
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={notify} className="mt-2">
          <label className="text-xs tracking-[0.25em] uppercase text-gray-400">Email</label>
          <div className="mt-2 relative">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" size={16} />
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@email.com"
              data-testid="login-email-input"
              className="w-full pl-10 pr-3 py-3 rounded-lg bg-black/50 border border-white/10 text-white placeholder:text-gray-600 focus:border-[#D4AF37]/60 focus:outline-none"
            />
          </div>
          <DialogFooter className="mt-5">
            <button
              type="submit"
              disabled={busy}
              data-testid="login-notify-button"
              className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-[#D4AF37] text-black font-semibold hover:bg-[#FFD700] disabled:opacity-60 transition"
            >
              <Sparkles size={16} /> Notify me at launch
            </button>
          </DialogFooter>
          <p className="text-xs text-gray-500 mt-3 text-center">
            Existing clients can call us at <span className="text-[#D4AF37]">+91 84120 33559</span> for portfolio access.
          </p>
        </form>
      </DialogContent>
    </Dialog>
  );
}
